const getMarks = (quiz: any) => {
  let questions = 0;
  let marks = 0;
  let formatedMarks = 0;
  if (quiz) {
    questions = quiz.questions.length;
    marks = questions === 0 ? 0 : 100 / questions;
    formatedMarks = Number(marks.toFixed(2));
  }
  return { questions, marks: formatedMarks };
};

export default getMarks;
